import * as T from 'types'
import * as E from 'types/enums'

export const getFeaturesIncluded = (
  packageType: E.PackageType,
  pricingPackages: T.IPricingPackage[],
  items: T.IPricingPackageItem[],
): T.IPricingPackageItem[] => {
  const packageOfType: T.IPricingPackage | undefined = pricingPackages.find(
    (pricingPackage: T.IPricingPackage) => pricingPackage.name === packageType,
  )
  return items.map((item: T.IPricingPackageItem) => {
    const included
      = packageOfType
      && !!packageOfType.items.find((itemCheck: T.IPricingPackageItem) => itemCheck._id === item._id)
    return {
      included,
      ...item,
    }
  })
}

export const getPackageByName = (name: E.PackageType, pricingPackages: T.IPricingPackage[]) =>
  pricingPackages.find(pricingPackage => pricingPackage.name === name)

export const getFeaturesDifference = (
  itemsA: T.IPricingPackageItem[],
  itemsB: T.IPricingPackageItem[],
) =>
  itemsB.filter((itemB: T.IPricingPackageItem) => {
    const itemMatch = itemsA.find((itemA: T.IPricingPackageItem) => itemA._id === itemB._id)
    if (!itemMatch) return true // if there isn't a item, item should be displayed

    if (Object.prototype.hasOwnProperty.call(itemMatch, 'included')) return true // ditto if missing included prop

    if (itemMatch.included !== itemB.included) return true // not a shared item

    return false
  })

export const getUniqueFeatures = (pricingPackageItemSets: T.IPricingPackageItem[][]) =>
  pricingPackageItemSets.reduce(
    (accum: T.IPricingPackageItem[], itemSet: T.IPricingPackageItem[]) => {
      itemSet.forEach(item => {
        const itemMatch = accum.find(accumItem => accumItem._id === item._id)
        if (!itemMatch) accum.push(item)
      })
      return accum
    },
    pricingPackageItemSets[0],
  )

// types can be one of "service" (first), "help" (second), or "help" (third)
const typePriority: { [key: string]: number } = {
  [E.FeatureType.service]: 1,
  [E.FeatureType.help]: 2,
  [E.FeatureType.support]: 3,
}
export const sortPricingPackageItemsByTypeThenOrder = (
  pricingPackageItems: T.IPricingPackageItem[],
) =>
  pricingPackageItems.sort((a: T.IPricingPackageItem, b: T.IPricingPackageItem) => {
    if (!a.type || !b.type) return 0 // if no type, don't sort (shouldn't happen)

    if (!a.order || !b.order) return 0 // if no order, don't sort (shouldn't happen)

    if (a.type === b.type) return a.order - b.order

    return typePriority[a.type] - typePriority[b.type]
  })

export const getSortedDisclosures = (pricingPackageItems: T.IPricingPackageItem[]) =>
  sortPricingPackageItemsByTypeThenOrder(pricingPackageItems.filter(item => !!item.disclaimer))
    .map((item: T.IPricingPackageItem) => item.disclaimer)
    .filter(Boolean) as string[] // TS having problems understanding this

export const getDescription = (type: E.PackageType | string) => {
  switch (type) {
    case E.PackageType.basic:
      return 'No money down, pay $599 at closing, add a la carte services as you go. Flat Fee MLS.'
    case E.PackageType.premium:
      return 'A local MLS listing, plus the important tools to market your home like a pro.'
    case E.PackageType.platinum:
      return 'The complete package, with real estate experts guiding you the entire way.'
    default:
      return ''
  }
}
